export const LoadingCircle = () => {
    return (
        <div className="h-full fixed inset-0 bg-black bg-opacity-10 flex justify-center items-center z-50">
            <div className="w-16 h-16 border-4 border-blue-200 border-t-transparent rounded-full animate-spin"></div>
        </div>
    )
}
